import { useForm } from 'react-hook-form';
import { useCreateApplicationFormContext } from './context';
import {
  CreateApplicationFormDataValues,
  useCreateApplicationFormSchemaResolver,
} from './schema';
import { useCreateApplicationFormDefaultValues } from './defaultValues';
import { MarketCountryCode } from '@axo/shared/types';

export const useCreateApplicationForm = (marketCountry: MarketCountryCode) => {
  const formSchemaResolver = useCreateApplicationFormSchemaResolver();
  const defaultValues = useCreateApplicationFormDefaultValues(marketCountry);
  const formContext = useCreateApplicationFormContext(marketCountry);

  useForm<CreateApplicationFormDataValues>({
    defaultValues,
    values: defaultValues,
    resolver: formSchemaResolver,
    formControl: formContext.formControl,
    mode: 'all',
    reValidateMode: 'onChange',
    criteriaMode: 'all',
  });

  return formContext;
};
